export const SET_BREADCRUMBS = 'breadcrumbs/SET_BREADCRUMBS';
export const REMOVE_BREADCRUMB = 'breadcrumbs/REMOVE_BREADCRUMB';
export const REMOVE_BREADCRUMBS = 'breadcrumbs/REMOVE_BREADCRUMBS';
